import { STATUS_VALUE_ZERO } from "../../components/attendance/Constants";
import { deleteAward } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import {
    DELETE_AWARD_REQUEST,
    DELETE_AWARD_SUCCESS,
    DELETE_AWARD_FAILURE,
} from "./actionType";


const deleteAwardAction = (props) => {
    let { useDispatch, getAwardList, params, handleClose } = props
    return (dispatch) => {
        dispatch(deleteAwardRequest());
        deleteAward(params).then((res) => {
            let { status } = ResponseFilter(res)
            if (status) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        resAwardMsg: true,
                        successMessage: "Award Deleted",
                        loader: false
                    }
                })
                handleClose()
                getAwardList()
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resAwardMsg: false
                    }
                }), 3000);
            } else if (res.data.statusCode === STATUS_VALUE_ZERO) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        responseMessage: res.data.error.responseMessage,
                        errorCode: res.data.error.errorCode,
                        resAwardFailMsg: true,
                        loader: false
                    }
                })
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resAwardFailMsg: false
                    }
                }), 3000);
                getAwardList()
            }
        })
            .catch((error) => {
                dispatch(deleteAwardFailure(error));
            });
    };
};

const deleteAwardRequest = () => {
    return {
        type: DELETE_AWARD_REQUEST,
    };
};
const deleteAwardSuccess = (data) => {
    return {
        type: DELETE_AWARD_SUCCESS,
        payload: data,
    };
};
const deleteAwardFailure = (error) => {
    return {
        type: DELETE_AWARD_FAILURE,
        payload: error,
    };
};
export {
    deleteAwardAction,
    deleteAwardRequest,
    deleteAwardSuccess,
    deleteAwardFailure,
};